export default "__VITE_ASSET__BkTckCuQ__"